import React from 'react';
import clsx from 'clsx';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import {
  IconButton, Input,
  InputAdornment, FormControl
} from '@mui/material';

import { Search, Clear } from '@mui/icons-material';
import { isMobile } from '@ivymobi/orbit-core';

const useStyles = makeStyles(() =>
  createStyles({
    textField: {
      // width: '25ch',
      '& .MuiInputBase-root': {
        width: '140px',
        transition: 'width 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        '&.Mui-focused': {
          width: '180px',
        }
      }
    },
  }),
);

interface SearchInputProps {
  width?: number | string;
  placeholder?: string;
  doSearch: (val: string) => void;
  doCancel: () => void;
}
export default function SearchInput (props: SearchInputProps) {
  const {
    width = 240, placeholder = 'Search',
    doSearch, doCancel = () => console.log('cancel')
  } = props;
  const classes = useStyles();

  const [value, setValue] = React.useState('');
  const handleChange = (event) => setValue(event.target.value);
  const handleMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  return (
    <FormControl className={classes.textField} size='small'>
      <Input
        id="searchInput"
        type='text'
        value={value}
        style={{
          width: isMobile() ? 'unset' : width
        }}
        onChange={handleChange}
        placeholder={placeholder}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            doSearch(value);
          }
        }}
        endAdornment={
          <InputAdornment position="end">
            {value && <IconButton
              onClick={() => {
                setValue('');
                doCancel();
              }}
              onMouseDown={handleMouseDown}
              style={{ padding: 0 }}
              size="large">
              <Clear/>
            </IconButton>}
            <IconButton
              onClick={() => doSearch(value)}
              onMouseDown={handleMouseDown}
              style={{ padding: 0 }}
              size="large">
              <Search />
            </IconButton>
          </InputAdornment>
        }
      />
    </FormControl>
  );
}